import LayoutPage from "@/views/shared/LayoutPage"

export default [
    {
        path: '/purchase-order/approval',
        component: LayoutPage,
        children: [
            {
                path: "/purchase-order/approval",
                name: "purchase-order-approval",
                component: () => import("@/views/PurchaseOrderApproval.vue"),
                meta: {
                    title: "Purchase Order Approval",
                    titleLocalizationCode: "Purchase_Order_Approval",
                    desc: "Purchase order approval page",
                    descLocalizationCode: "Purchase_Order_Approval_Page",
                    layout:"LayoutPage",
                    sidebarElement: false
                },
            },
        ],
        
    }
]


